import auth from "./auth";
import router from "../router";
import axios from "axios";

function simpleDelete(url, data, options) {
    createHttpRequest().then(
        http => {
            http
                .delete(url, { data: data })
                .then(function (response) {
                    if (options.success) {
                        options.success(response);
                    }
    
                    if (options.finally) {
                        options.finally();
                    }
                })
                .catch(function (error) {
                    if(error && error.response && error.response.status == 403){
                        handleUnauthorisedResponse();
                    }

                    if (options.error) {
                        options.error(error);
                    }
    
                    if (options.finally) {
                        options.finally();
                    }
                })
        },
        rejected => {
            if (options.error) {
                options.error(rejected);
            }

            if (options.finally) {
                options.finally();
            }
        }
    );
}

function simplePost(url, data, options) {
    createHttpRequest().then(
        http => {
            http
                .post(url, data)
                .then(function (response) {
                    if (options.success) {
                        options.success(response);
                    }
    
                    if (options.finally) {
                        options.finally();
                    }
                })
                .catch(function (error) {
                    if(error && error.response && error.response.status == 403){
                        handleUnauthorisedResponse();
                    }

                    if (options.error) {
                        options.error(error);
                    }
    
                    if (options.finally) {
                        options.finally();
                    }
                })
        },
        rejected => {
            if (options.error) {
                options.error(rejected);
            }

            if (options.finally) {
                options.finally();
            }
        }
    );
}

function simpleGet(url, options) {
    createHttpRequest().then(
        http => {
            http
                .get(url, {
                    params: options.params
                })
                .then(function (response) {
                    if (options.success) {
                        options.success(response);
                    }
    
                    if (options.finally) {
                        options.finally();
                    }
                })
                .catch(function (error) {
                    if(error && error.response && error.response.status == 403){
                        handleUnauthorisedResponse();
                    }

                    if (options.error) {
                        options.error(error);
                    }
    
                    if (options.finally) {
                        options.finally();
                    }
                })
        },
        rejected => {
            if (options.error) {
                options.error(rejected);
            }

            if (options.finally) {
                options.finally();
            }
        }
    );
}

function saveStore(store, options) {
    if (store.LogoData) {
        var buffer = new Buffer(store.LogoData, "base64");

        // 10 MB
        if (buffer.length > (5*1024*1024)) {
            var err = new Error("Logo file size must be less than 5 MB");

            if (options.error) {
                options.error(err);

                if (options.finally) {
                    options.finally();
                }

                return;
            }
            else {
                throw err;
            }
            
        }
    }

    simplePost("/stores", store, options);
}

function fetchCategories(options) {
    simpleGet("/categories", options);
}

function fetchProducts(options) {
    simpleGet("/products", options);
}

function fetchBankingDetails(options) {
    simpleGet("/bankingdetails", options);
}

function fetchSuppliers(options) {
    simpleGet("/suppliers", options);
}

function fetchSupplierProducts(options) {
    // params is used for query string parameters
    var params = {
        SupplierID: options.id,
        SupplierProducts: ""
    }
    
    if (options.params) {
        options.params = Object.assign(options.params, params);
    }
    else {
        options.params = params;
    }

    simpleGet("/suppliers", options);
}

function fetchSupplierProductsForStore(options) {
    // params is used for query string parameters
    var params = {
        StoreID: options.id,
        SupplierProductsForStore: ""
    }
    
    if (options.params) {
        options.params = Object.assign(options.params, params);
    }
    else {
        options.params = params;
    }

    simpleGet("/suppliers", options);
}

function fetchStores(options) {
    simpleGet("/stores", options);
}

function fetchDepartments(options) {
    simpleGet("/departments", options);
}

function fetchProductTypes(options) {
    simpleGet("/productTypes", options);
}

function fetchUsers(options) {
    simpleGet("/users", options);
}

function getUser(options){
    simpleGet("/user", options);
}

function saveUser(user, options) {
    simplePost("/user", user, options);
}

function fetchAuditLogs(options) {
    simpleGet("/auditLogs", options);
}

function fetchAuditLogValues(options){
    simpleGet("/auditLogValues", options);
}

function saveCategory(category, options) {
    simplePost("/categories", category, options);
}

function saveProduct(product, options) {
    simplePost("/products", product, options);
}

function saveBankingDetails(bankingDetails, options) {
    simplePost("/bankingdetails", bankingDetails, options);
}

function saveSupplier(supplier, options) {
    simplePost("/suppliers", supplier, options);
}

function saveSupplierProducts(supplierID, supplierProducts, options) {
    simplePost("/suppliers", {supplierID: supplierID, supplierProducts: supplierProducts}, options);
}

function fetchPublicHolidays(options) {
    simpleGet("/publicHolidays", options);
}

function savePublicHoliday(publicHoliday, options) {
    simplePost("/publicHolidays", publicHoliday, options);
}

function fetchOrders(options) {
    simpleGet("/orders", options);
}

function saveOrder(order, options) {
    simplePost("/orders", order, options);
}

function saveOrdersProductsComments(ordersProductsComment, options) {
    simplePost("/ordersProductsComments", ordersProductsComment, options);
}

function fetchOrderProducts(options) {
    simpleGet("/ordersProducts", options);
}

function fetchOrderProductsComments(options) {
    simpleGet("/ordersProductsComments", options);
}

function fetchStoreSuppliers(options) {
    // params is used for query string parameters
    var params = {
        StoreID: options.storeID,
    }
    
    if (options.params) {
        options.params = Object.assign(options.params, params);
    }
    else {
        options.params = params;
    }

    simpleGet("/storesuppliers", options);
}

function saveStoreSuppliers(data, options) {
    simplePost("/storesuppliers", data, options);
}

function copyStoreSupplier(data, options) {
    simplePost("/storesuppliers", data, options);
}

function deleteStoreSupplier(data, options) {
    simpleDelete("/storesuppliers", data, options);
}

function assignToStores(data, options) {
    console.log('assign to stores', data, options)
    simplePost("/storesuppliers/assigntostores", data, options);
}

function fetchGPReports(options) {
    // params is used for query string parameters
    var params = {
        GPReports: ""
    }
    
    if (options.params) {
        options.params = Object.assign(options.params, params);
    }
    else {
        options.params = params;
    }

    simpleGet("/reports", options);
}

function fetchGPReportsByDate(options) {
    // params is used for query string parameters
    var params = {
        GPReportsByDate: ""
    }
    
    if (options.params) {
        options.params = Object.assign(options.params, params);
    }
    else {
        options.params = params;
    }

    simpleGet("/reports", options);
}

function fetchOrderReports(options){
    // params is used for query string parameters
    var params = {
        OrdersSentReport: ""
    }

    if (options.params) {
        options.params = Object.assign(options.params, params);
    }
    else {
        options.params = params;
    }

    simpleGet("/reports", options);
}

function fetchDetailedOrderReport(options) {
    // params is used for query string parameters
    var params = {
        DetailedOrderReport: ""
    }

    if (options.params) {
        options.params = Object.assign(options.params, params);
    }
    else {
        options.params = params;
    }

    simpleGet("/reports", options);
}

function resendSupplierEmails(orderID, supplierIDs, options) {
    simplePost("/orders/" + orderID + "?ResendEmails=true", supplierIDs, options)
}

/**
 * Function to create an axios request with an authenticated AD token
 *
 */
function createHttpRequest() {
    return new Promise(function (resolve, reject) {
        auth.acquireToken().then(token => {
            resolve(
                axios.create({
                    baseURL: process.env.VUE_APP_API_URI,
                    headers: {
                        Authorization: token
                    },
                    responseType: "text"
                })
            );
        }).catch(err => {
            reject(err);
        });
    });
}

// https://github.com/axios/axios#handling-errors
function parseHttpRequestError(error) {
    if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);

        return error.response.status +  " error: " + error.message + " - " + JSON.stringify(error.response.data);
    }
    else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        return "A request was made but no response was received from the server";
    }
    else {
        // Something happened in setting up the request that triggered an Error
        return error.message;
    }
}

function handleUnauthorisedResponse(){
    return new Promise(function (resolve, reject) {
        auth.processLogin().then(() => {
            router.push({
                path: "/notauthorized"
            });
        }, () => {
            router.push({
                path: "/loginerror"
            });
        });
    });
}

export default {
    getUser,
    fetchDepartments,
    fetchStores,
    parseHttpRequestError,
    saveStore,
    fetchUsers,
    saveUser,
    fetchAuditLogs,
    fetchAuditLogValues,
    fetchCategories,
    saveCategory,
    fetchProducts,
    saveProduct,
    fetchSuppliers,
    saveSupplier,
    fetchSupplierProducts,
    fetchSupplierProductsForStore,
    saveSupplierProducts,
    fetchPublicHolidays,
    savePublicHoliday,
    fetchOrders,
    saveOrder,
    fetchOrderProducts,
    fetchBankingDetails,
    saveBankingDetails,
    fetchStoreSuppliers,
    saveStoreSuppliers,
    deleteStoreSupplier,
    copyStoreSupplier,
    fetchGPReports,
    fetchGPReportsByDate,
    resendSupplierEmails,
    assignToStores,
    saveOrdersProductsComments,
    fetchOrderProductsComments,
    fetchProductTypes,
    fetchOrderReports,
    fetchDetailedOrderReport
};
